import { type BaseConfig, useConfig as hook } from '@eika-infrastruktur/config-provider';
import nbTranslations from '@translation-utils/nb-translations-config';
import type TranslationsConfigType from '@translation-utils/translation-type';
import { type Links, links } from './config/links';
import { isMalbankBankRegnr } from './types/bankregnr';

export interface Config extends BaseConfig {
    links: Links;
    siteLang: 'nb' | 'nn';
    translations: {
        nb: TranslationsConfigType;
        nn: TranslationsConfigType;
    };
    // Calculator config for future customization of how the calculator should look
    // Only type standard in V1
    calculatorConfig: {
        type: 'standard';
        includeSliders: boolean;
    };
    bankConfig: {
        showContactAdvisorButton: boolean;
    };
}

export const defaultConfig: Config = {
    links,
    siteLang: 'nb' as const,
    translations: {
        nb: nbTranslations,
        nn: nbTranslations, // TODO: Set as nnTranslations when available
    },
    calculatorConfig: {
        type: 'standard',
        includeSliders: false,
    },
    bankConfig: {
        showContactAdvisorButton: true,
    },
};

function createHook<T>(): () => T {
    return () => hook<T>();
}

export const useConfig = createHook<typeof defaultConfig>();

export const useAppConfig = (): typeof defaultConfig => {
    const config = useConfig();

    const showContactAdvisorButton = !!config.bankregnr && isMalbankBankRegnr(config.bankregnr);

    return {
        ...config,
        bankConfig: {
            ...config.bankConfig,
            showContactAdvisorButton: config.bankConfig.showContactAdvisorButton && showContactAdvisorButton,
        },
    };
};
